// Login.js
import React from 'react';
import { getLinkedInAuthUrl } from 'helpers/linkedinAuthHelper';

const LoginLinkedIn = () => {
  const handleLogin = () => {
    window.location.href = getLinkedInAuthUrl();
  };

  return (
    <div>
      <button onClick={handleLogin}>Login with LinkedIn</button>
    </div>
  );
};

export default LoginLinkedIn;